import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {Link} from "../link/link";
import {TOOLTIP_PLACEMENT} from "../tooltip/tooltip-consts";
import {Tooltip} from "../tooltip/tooltip";
import {WINNER_STATUSES} from "../../consts";
import styles from "./game-badge.module.scss";
import classnames from "classnames";
import type {ModuleController} from "../../../infrastructure/controllers/module-controller";

export class GameBadgeProps extends BaseProps {
  className: String;
  link: BaseLinkModel;
  routeProps: Object;
  textClassName: String;
  isSmallView: Boolean;
  tooltipContent: String;
  controller: ModuleController;
  onClick: Function;
}

export const GameBadge = ({
                            controller,
                            tooltipContent,
                            className,
                            onClick,
                            link,
                            winnerStatus,
                            routeProps
                          }: GameBadgeProps) => {
  const {state: {terms, device}} = controller;
  const {isSmallView} = device;

  const tooltipProps = {
    placement: TOOLTIP_PLACEMENT.bottom,
    content: tooltipContent,
  }

  const colors = {
    [WINNER_STATUSES.win]: styles.win,
    [WINNER_STATUSES.draw]: styles.draw,
    [WINNER_STATUSES.lose]: styles.lose
  }
  const colorClassName = colors[winnerStatus];

  const linkProps = {
    className: classnames(styles.container, {[styles.small_view]: isSmallView}, colorClassName, className),
    model: link,
    routeProps: routeProps,
    onClick: () => onClick && onClick()
  }

  const {
    GAME_CENTER_H2H_WIN,
    GAME_CENTER_H2H_DRAW,
    GAME_CENTER_H2H_LOSE,
  } = terms;

  const statusTexts = {
    [WINNER_STATUSES.win]: GAME_CENTER_H2H_WIN,
    [WINNER_STATUSES.draw]: GAME_CENTER_H2H_DRAW,
    [WINNER_STATUSES.lose]: GAME_CENTER_H2H_LOSE
  }

  const text = statusTexts[winnerStatus];

  return (
    <Link {...linkProps}>
      <Tooltip {...tooltipProps}>
        <div className={classnames(styles.text)}>{text}</div>
      </Tooltip>
    </Link>

  )
}
